import axios from '../axios'
import { getURL, jsonToFormData, jsonToParam } from 'src/utils/config';
import { handleResponse } from 'src/utils/responseHandler';


const addCredits = (formdata, callback) => {
    axios({
        method: 'post',
        url: getURL('invoice/add-client-credits'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addStorage = (formdata, callback) => {
    axios({
        method: 'post',
        url: getURL('invoice/add-additional-amount-details'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getCredits = (callback) => {
    axios({
        method: 'get',
        url: getURL('invoice/client-credits'),
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getStorage = (callback) => {
    axios({
        method: 'get',
        url: getURL('invoice/additional-amount-details'),
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const updateStorage = (formdata, callback) => {
    axios({
        method: 'put',
        url: getURL('invoice/update-additional-amount-details'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const updateCredits = (formdata,callback) => {
    axios({
        method: 'put',
        url: getURL('invoice/update-client-credits'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addClientCameraPricing = (formdata, callback) => {
    axios({
        method: 'post',
        url: getURL('invoice/add-client-camera-pricing'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getClientCameraPricing = (callback) => {
    axios({
        method: 'get',
        url: getURL('invoice/client-camera-pricing'),
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const updateClientCameraPricing = (formdata,callback) => {
    axios({
        method: 'put',
        url: getURL('invoice/update-client-camera-pricing'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const addInvoiceGrouping = (formdata, callback) => {
    axios({
        method: 'post',
        url: getURL('invoice/add-client-invoice-contact'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getInvoiceGrouping = (callback) => {
    axios({
        method: 'get',
        url: getURL('invoice/client-invoice-contact'),
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const updateInvoiceGrouping = (formdata,callback) => {
    axios({
        method: 'put',
        url: getURL('invoice/update-client-invoice-contact'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getDashboardData = (data,callback) => {
    const {month,year} = data;
    const url = `invoice/billing-summary?year=${year}&month=${month}`
    axios({
        method: 'get',
        url: getURL(url),
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const updateOutstanding = (formdata,callback) => {
    axios({
        method: 'put',
        url: getURL('invoice/update-outstanding-price'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const updateInvoiceApproval = (formdata, callback) => {
    axios({
        method: 'post',
        url: getURL('invoice/add-or-update-invoice-approval'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

const getInvoiceData = (data,callback) => {
    const {month,year,invoice_id,clientId} = data;
    //let url = ''
    let url = `/invoice/invoice-preview?year=${year}&month=${month}&client_id=${clientId}`
    if(invoice_id === null || invoice_id === undefined || invoice_id === ''){
        
    }
    else{
         url = `/invoice/invoice-preview?year=${year}&month=${month}&invoice_id=${invoice_id}`
    }
    
    axios({
        method: 'get',
        url: getURL(url),
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}
const sendInvoiceEmail = (formdata, callback) => {
        const {
        month,
        year,
        invoice_id,
        clientId,
        mail_type
    } = formdata;

     let url = `client-reports/send-client-monthly-invoice-mail?month=${month}&year=${year}&invoice_id=${invoice_id}`;

    if (clientId) {
        url += `&clientId=${clientId}`;
    }

    if (mail_type) {
        url += `&mail_type=${mail_type}`;
    }
    axios({
        method: 'get',
        url: getURL(url),
        //data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}


const updateEditReason = (formdata,callback) => {
    axios({
        method: 'put',
        url: getURL('invoice/update-edit-reason'),
        data: formdata,
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response))
}

export {addStorage,getStorage,updateStorage,updateEditReason,updateInvoiceApproval,getInvoiceData,updateOutstanding,getDashboardData,addCredits,addClientCameraPricing,getClientCameraPricing,getCredits,updateCredits,updateClientCameraPricing,addInvoiceGrouping,getInvoiceGrouping,updateInvoiceGrouping,sendInvoiceEmail}
